import React from 'react'
import {Icon} from '@chakra-ui/react'

const FeedbackWarningIcon = (props) => {
    return (
        <Icon viewBox="0 0 20 20" fill="none" {...props}>
            <g clipPath="url(#clip0_feedback_warning)">
                <path
                    d="M3.20834 7.18333C3.08671 6.63544 3.10539 6.0657 3.26264 5.52695C3.41989 4.9882 3.71063 4.49787 4.1079 4.10143C4.50517 3.705 4.9961 3.41529 5.53518 3.25916C6.07426 3.10304 6.64404 3.08555 7.19167 3.20833C7.4931 2.73692 7.90834 2.34897 8.39913 2.08024C8.88992 1.81151 9.44046 1.67065 10 1.67065C10.5596 1.67065 11.1101 1.81151 11.6009 2.08024C12.0917 2.34897 12.5069 2.73692 12.8083 3.20833C13.3568 3.08502 13.9276 3.10242 14.4675 3.25893C15.0074 3.41543 15.499 3.70595 15.8965 4.10346C16.2941 4.50097 16.5846 4.99256 16.7411 5.5325C16.8976 6.07244 16.915 6.64319 16.7917 7.19167C17.2631 7.49309 17.651 7.90834 17.9198 8.39913C18.1885 8.88992 18.3294 9.44046 18.3294 10C18.3294 10.5595 18.1885 11.1101 17.9198 11.6009C17.651 12.0917 17.2631 12.5069 16.7917 12.8083C16.9145 13.356 16.897 13.9257 16.7408 14.4648C16.5847 15.0039 16.295 15.4948 15.8986 15.8921C15.5021 16.2894 15.0118 16.5801 14.4731 16.7374C13.9343 16.8946 13.3646 16.9133 12.8167 16.7917C12.5156 17.2649 12.1001 17.6545 11.6084 17.9244C11.1168 18.1944 10.565 18.3359 10.0042 18.3359C9.44332 18.3359 8.89153 18.1944 8.3999 17.9244C7.90828 17.6545 7.49271 17.2649 7.19167 16.7917C6.64404 16.9144 6.07426 16.897 5.53518 16.7408C4.9961 16.5847 4.50517 16.295 4.1079 15.8986C3.71063 15.5021 3.41989 15.0118 3.26264 14.4731C3.10539 13.9343 3.08671 13.3646 3.20834 12.8167C2.73331 12.516 2.34202 12.1001 2.07088 11.6077C1.79974 11.1152 1.65756 10.5622 1.65756 10C1.65756 9.43783 1.79974 8.88479 2.07088 8.39232C2.34202 7.89986 2.73331 7.48396 3.20834 7.18333Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    opacity="0.1"
                    d="M6 3.75L6 15.75M14 3.75V15.75"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M10 6.66669V10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10 13.3333H10.0083"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_feedback_warning">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default FeedbackWarningIcon
